import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctTupleArray, FctValueList } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { kiroboMulticallContracts } from '../constants';
export var MultiAllowanceCSV = createPlugin({
    protocol: 'KIROBO_MULTICALL_CSV',
    type: 'LIBRARY:VIEWONLY',
    toEns: '@lib:multicall',
    method: 'multiAllowance',
    name: 'multiAllowanceCSV',
    supportedContracts: kiroboMulticallContracts,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    'allowances_tuple[]': new FctTupleArray({
                        params: {
                            token: new FctAddressList({ options: getSupportedTokens({ chainId: chainId }) }),
                            owner: new FctAddressList({}),
                            spender: new FctAddressList({}),
                        },
                    }),
                },
            },
            output: {
                allowances: new FctValueList({}),
            },
        });
    },
});
